import { Card, Snackbar, SnackbarProps } from '@mui/material'
import { AlertColor } from '@mui/material/Alert/Alert'
import Slide, { SlideProps } from '@mui/material/Slide'
import { C1Alert, C1IconButton } from 'c1ui'
import { C1Icon } from 'components/core/icons/C1Icon'
import { X } from 'lucide-react'

type TransitionProps = Omit<SlideProps, 'direction'>
const TransitionLeft = (props: TransitionProps): React.ReactElement => {
    return <Slide {...props} direction="left" />
}

export type C1SnackBarProps = SnackbarProps & {
    severity: AlertColor
}

export const C1SnackBar = (props: C1SnackBarProps): React.ReactElement => (
    <Snackbar
        {...props}
        anchorOrigin={props.anchorOrigin ?? { vertical: 'top', horizontal: 'right' }}
        TransitionComponent={TransitionLeft}
    >
        <Card>
            <C1Alert
                severity={props.severity || 'success'}
                action={props.autoHideDuration === null && <C1IconButton
                    aria-label="close"
                    color="inherit"
                    sx={{ height: '24px', width: '24px' }}
                    onClick={(e): void => props.onClose?.(e, 'clickaway')}
                >
                    <C1Icon icon={X} />
                </C1IconButton>}
            >
                {props.children}
            </C1Alert>
        </Card>
    </Snackbar>
)
